import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withCtx as _withCtx, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-084fc45b"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home-ctn flex-column" }
const _hoisted_2 = { class: "top-box" }
const _hoisted_3 = { class: "van_has_bg" }
const _hoisted_4 = { class: "two_div" }
const _hoisted_5 = /*#__PURE__*/_createTextVNode(" 关键词搜索资源")
const _hoisted_6 = ["src"]
const _hoisted_7 = ["src"]
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "img_p" }, null, -1))
const _hoisted_9 = { class: "menus-ctn" }
const _hoisted_10 = ["onClick"]
const _hoisted_11 = { class: "bottom-box flex-1 flex-column" }
const _hoisted_12 = {
  class: "list-ctn flex-1",
  style: {"overflow":"auto"}
}
const _hoisted_13 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "资源专栏")
], -1))
const _hoisted_14 = ["src"]
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "block-title" }, [
  /*#__PURE__*/_createElementVNode("span", null, "热门资源")
], -1))
const _hoisted_16 = ["onClick"]
const _hoisted_17 = { class: "img-ctn" }
const _hoisted_18 = ["src"]
const _hoisted_19 = { class: "p_1" }
const _hoisted_20 = { class: "zymc" }

import wx from "weixin-js-sdk"
import { ref, onMounted, onBeforeMount, watch, onActivated, defineAsyncComponent } from "vue"
import axios from "axios"
// import Cities from "@/components/Cities.vue"
import router from "@/router"
import { useRoute } from "vue-router"
import { getTokenIn } from "@/utils/cookies"
import ListWithRefreshAndLazyLoad from "@/components/ListWithRefreshAndLazyLoad.vue"
import {
  getResourceApi,
  squarePageApi,
  getImgListApi,
  hotListApi,
  addFeedBackApi,
  getNewCodeApi,
  addCodeApi,
  updateCodeApi,
  getcityCodeApi,
  resourceSectionPageApi
} from "@/api/home"
import { useMapStore } from "@/store/modules/map"
import { getTokenAPi } from "@/api/login"
import { authoritiesApi } from "@/api/user" // 获取用户权限
import { showNotify, showLoadingToast, closeToast, showConfirmDialog } from "vant"
import { setToken, getToken, getCityCode, getNoLoginCityCodeHome } from "@/utils/cookies"
import { areaList } from "@vant/area-data"
import DataList from "@/api/common"
import commons from "@/utils/commons"

const __default__ = {
  name: "Home"
}

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  setup(__props) {

const route = useRoute()
const getDataAPI = hotListApi // 获取列表接口
const Cities = defineAsyncComponent(() => import("@/components/Cities.vue"))
const mapStore = useMapStore()
const pageOnload = ref(false)
const listRef: any = ref(null)
const list: any = ref([])
const noData = ref(false)
const circle = ref(true)
const cityParams: any = ref({
  name: "",
  code: "",
  add: false,
  sfid: ""
}) //定位参数
const menus: any = [
  { name: "资源广场", icon: "plaza", path: "/resource/plazaGC" },
  { name: "资源地图", icon: "map", path: "/resource/mapNew" },
  { name: "政策资讯", icon: "infomation", path: "/policy" },
  { name: "论坛", icon: "forum", path: "/projectDemand" }
  // { name: "身份认证", icon: "forum", path: "" }
]
const imgList = ref([])
const imgList2 = ref([{}, {}])
const zyImgList = ref([])
// 获取缓存里面的数据
const params: any = ref({
  xzqhbm: getNoLoginCityCodeHome() || "",
  size: 10,
  xj: "4.5",
  isCity: 1
})
watch(
  () => list.value,
  (newVal, oldVal) => {
    if (newVal.length == 0) {
      noData.value = true
    } else {
      noData.value = false
    }
  },
  {
    deep: true
  }
)
watch(
  () => params.value,
  (newVal) => {
    // const data: any = {
    //   cityCode: newVal.xzqhbm,
    //   countryCode: ""
    // }
    // mapStore.setXzqhbm(data)
  },
  {
    deep: true
  }
)
// watch(
//   () => params.value.xzqhbm,
//   (newVal) => {
//     addNum.value += 1
//     if (addNum.value === 1 && getTokenIn()) {
//       setTimeout(() => {
//         // 获取用户最新的位置记录
//         getCityCodeDetail()
//       }, 200)
//     }
//   },
//   {
//     deep: true,
//     immediate: true
//   }
// )
const reSearch = () => {
  listRef.value.onRefresh()
  // 未登录进行缓存
  sessionStorage.setItem("noLogincityCodeHome", params.value.xzqhbm)
  // 需要判断是新增还是编辑，再记录用户定位参数
  // if (cityParams.value.add) {
  //   // 新增
  //   addCodeDetail()
  // } else {
  //   // 编辑
  //   editCodeDetail()
  // }
}
// 获取图片地址
const getimgUrl = (item: any, num: any) => {
  var id = num == 1 ? item.imageResourceSfid : item.fmtpDetail2?.sfid || item.fmtpDetail?.sfid
  var url = DataList.UpdtImagePrefix() + id
  return url
}
// 获取资源专栏图片地址
const getResourceimgUrl = (item: any) => {
  var url = DataList.UpdtImagePrefix() + item.topImageId
  return url
}
// 获取行政区名称
const getAreaName = (item: object) => {
  var code = item.xzqhbm
  return areaList.city_list[code] || areaList.province_list[code] || areaList.county_list[code] || "未知区域"
}
const gotoSearch = () => {
  router.push({ path: "/resource/search" })
}
const gotoDetail = (item: any) => {
  // if (getToken()) {
  //记录浏览量
  var datas = {
    originalSfid: item.sfid,
    type: "resource"
  }
  addFeedBackApi(datas).then(() => {})
  // }
  // 缓存滚动条滚动的高度
  const height: any = document.getElementsByClassName("list-ctn")[0].scrollTop
  console.log(document.getElementsByClassName("list-ctn")[0])
  sessionStorage.setItem("homeScroll", height)
  router.push({ path: "/resource/detail", query: { id: item.sfid } })
}
const goto = (item: any) => {
  if (item.path && item.name != "身份认证") {
    router.push({ path: item.path })
  } else if (item.name == "身份认证") {
    commons.isLoginIsAuthentication("falseConfirmDialog", () => {
      // 额外的执行方法
    })
  }
}
onActivated(() => {
  params.value.xzqhbm = getNoLoginCityCodeHome() || ""
  // listRef.value?.onRefresh()
  if (route.meta.isReach) {
    getImgList() //获取图片列表
    listRef.value?.onRefresh()
  }
  if (route.meta.catch && !route.meta.keepAlive && !route.meta.isReach) {
    const height: any = sessionStorage.getItem("homeScroll")
    document.getElementsByClassName("list-ctn")[0].scrollTop = height || 0
  }
})
onMounted(() => {
  setTimeout(() => {
    pageOnload.value = true
  }, 500)
  getImgList() //获取图片列表
  getResourceImg()
  // 判断从壳子跳过来进行登录
  if (route.query.from || route.query.loginCode) {
    // 缓存登录标示字段
    var loginCode: any = route.query.loginCode
    localStorage.setItem("loginCode", loginCode)
    // 根据登录账号获取token
    getTokens(route.query.from || route.query.loginCode)
    // 缓存openid备用
    if (route.query.openId) {
      localStorage.setItem("openId", route.query.openId)
    }
  }

  // 如果有缓存就是用缓存数据城市定位
  params.value.isCity = 2
  // if (getNoLoginCityCodeHome()) {
  //   params.value.xzqhbm = getNoLoginCityCodeHome() || ""
  // }
  //  城市定位
  if (!sessionStorage.getItem("isFirstGo")) {
    getPosition()
    sessionStorage.setItem("isFirstGo", "1")
  }
})
// 获取用户最新位置信息，如果没有获取到就用定位信息，如果获取到就用记录的位置信息
const getCityCodeDetail = async () => {
  getPosition().then(() => {
    getNewCodeApi("首页").then((res: any) => {
      if (res.code == 200) {
        if (res.data == null) {
          // 表明从未记录用户定位信息
          cityParams.value.add = true
          // 刷新数据
          params.value.isCity = 2
          setTimeout(() => {
            // 使用定位参数
            // params.value.xzqhbm = cityParams.value.code || ""
            //  listRef.value?.onRefresh()
          }, 100)
        } else {
          cityParams.value.add = false
          params.value.isCity = 2
          // 刷新数据
          setTimeout(() => {
            //使用记录的的定位参数
            // params.value.xzqhbm = res.data.code
            cityParams.value.sfid = res.data.sfid
            listRef.value?.onRefresh()
          }, 100)
        }
      } else {
        showNotify({ type: "danger", message: res.message })
      }
    })
  })
}
// 添加用户操作的城市选择
const addCodeDetail = () => {
  if (getTokenIn()) {
    addCodeApi({
      code: params.value.xzqhbm,
      pageCode: "首页"
    }).then((res: any) => {
      if (res.code == 200) {
        console.log(res)
        // 刷新数据
        //listRef.value?.onRefresh()
      } else {
        showNotify({ type: "danger", message: res.message })
      }
    })
  }
}
// 编辑用户操作的城市选择
const editCodeDetail = () => {
  if (getTokenIn()) {
    updateCodeApi({
      code: params.value.xzqhbm,
      pageCode: "首页",
      sfid: cityParams.value.sfid
    }).then((res: any) => {
      if (res.code == 200) {
        console.log(res)
        // 刷新数据
        // listRef.value?.onRefresh()
      } else {
        showNotify({ type: "danger", message: res.message })
      }
    })
  }
}
// 获取token
const getTokens = async (datas: any) => {
  showLoadingToast({
    message: "登录中..."
  })
  getTokenAPi(datas, commons.setT026()).then((res: any) => {
    closeToast()
    if (res.code == 200) {
      setToken(res.data)
      localStorage.setItem("token-key", res.data)
      showNotify({ type: "success", message: "登录成功" })
      // 获取用户最新的位置记录
      // getCityCodeDetail()
      router.replace({ path: "/home" })
    } else {
      router.replace({ path: "/home" })
    }
  })
}
// 获取图片列表
const getImgList = async () => {
  // status	状态,1-启用 0-禁用
  var datas = {
    status: 1
  }
  showLoadingToast({
    message: "加载中"
  })
  getImgListApi(datas).then((res: any) => {
    if (res.code == 200) {
      imgList.value = []
      circle.value = true
      closeToast()
      if (res.data.length == 1) {
        imgList.value.push(res.data[0])
        imgList.value.push(res.data[0])
        circle.value = false
      } else {
        imgList.value = res.data.slice(0, 7)
        circle.value = true
      }
    } else {
      closeToast()
      showNotify({ type: "danger", message: res.message })
    }
  })
}
// 轮播图点击
const swipeClick = (item: any) => {
  wx.miniProgram.navigateTo({
    url: `/pages/webview/webview?previewUrl=${item.imageLink}`
  })
  // router.push({ path: "/webView", query: { url: item.imageLink } })
  // window.open(item.imageLink, "_blank")
  // window.location.href = item.imageLink
}
// 资源专栏轮播图点击
const swipeClickColumn = (item: any) => {
  router.push({ path: "/column", query: { sfid: item.sfid } })
}
// 获取经纬度，转换为城市code
const getPosition = async () => {
  if (navigator.geolocation) {
    navigator.geolocation.getCurrentPosition(
      (e) => {
        // showNotify({ type: "success", message: "获取地理位置成功" })
        console.log(e)
        const la = e.coords.latitude
        const lo = e.coords.longitude
        console.log(la)
        console.log(lo)
        // 转换为城市编码
        changeCityCode(lo, la)
      },
      (error) => {
        showNotify({ type: "warning", message: "无法获取地理位置信息" })
      }
    )
  } else {
    showNotify({ type: "warning", message: "浏览器不支持地理定位API" })
  }
}
// 经纬度转换为城市编码
const changeCityCode = (la: any, lo: any) => {
  getcityCodeApi(la, lo).then((res: any) => {
    console.log(res)
    if (res.status == "0" && res.msg == "ok") {
      const datas = res.result.addressComponent
      cityParams.value.name = datas.city
      cityParams.value.code = datas.city_code.slice(3)
      const index = datas.city.indexOf("市")
      console.log("城市名字：")
      console.log(datas.city)
      localStorage.setItem("cityName", datas.city.substring(0, index + 1))
      localStorage.setItem("cityCode", datas.city_code.slice(3))
      // params.value.xzqhbm = datas.city_code.slice(3) || "350200"
      if (!getTokenIn()) {
        // 使用定位参数
        // params.value.xzqhbm = datas.city_code.slice(3) || ""
        // 刷新数据
        // list.value = []
        // listRef.value?.onRefresh()
      }
      const data: any = {
        code: datas.city_code.slice(3),
        searchTpye: "城市"
      }
      mapStore.setXzqhbm(data)
    }
  })
}
// 获取资源专栏轮播图片
const getResourceImg = () => {
  resourceSectionPageApi({ current: 1, size: 99999999 }).then((res: any) => {
    if (res.code == 200) {
      console.log(res)
      if (res.data.records && res.data.records.length > 0) {
        zyImgList.value = res.data.records
      }
    } else {
      showNotify({ type: "danger", message: res.message })
    }
  })
}

return (_ctx: any,_cache: any) => {
  const _component_van_icon = _resolveComponent("van-icon")!
  const _component_van_swipe_item = _resolveComponent("van-swipe-item")!
  const _component_van_swipe = _resolveComponent("van-swipe")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          (pageOnload.value)
            ? (_openBlock(), _createBlock(_unref(Cities), {
                key: 0,
                city: params.value.xzqhbm,
                "onUpdate:city": _cache[0] || (_cache[0] = ($event: any) => ((params.value.xzqhbm) = $event)),
                nullCityName: "城市",
                onChange: _cache[1] || (_cache[1] = ($event: any) => (reSearch()))
              }, null, 8, ["city"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", {
            class: "search",
            onClick: gotoSearch
          }, [
            _createVNode(_component_van_icon, { name: "search" }),
            _hoisted_5
          ])
        ]),
        (imgList.value.length > 0)
          ? (_openBlock(), _createBlock(_component_van_swipe, {
              key: 0,
              class: _normalizeClass(['swipe-ctn', imgList.value.length == 2 && !circle.value ? 'swipe-ctn2' : '']),
              autoplay: 3000,
              loop: true,
              "indicator-color": "#eeb230"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_van_swipe_item, {
                    key: index,
                    class: "van-swipe-item",
                    onClick: ($event: any) => (swipeClick(item))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "home_img",
                        fit: "cover",
                        src: getimgUrl(item, '1'),
                        alt: ""
                      }, null, 8, _hoisted_6)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["class"]))
          : (_openBlock(), _createBlock(_component_van_swipe, {
              key: 1,
              class: "swipe-ctn swipe-ctn2",
              autoplay: 3000,
              loop: true,
              "indicator-color": "#eeb230"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(imgList2.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_van_swipe_item, {
                    key: index,
                    class: "van-swipe-item",
                    onClick: ($event: any) => (swipeClick(item))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "home_img",
                        fit: "cover",
                        src: item,
                        alt: ""
                      }, null, 8, _hoisted_7),
                      _hoisted_8
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            }))
      ]),
      _createElementVNode("ul", _hoisted_9, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(menus, (item, i) => {
          return _createElementVNode("li", {
            key: i,
            onClick: ($event: any) => (goto(item))
          }, [
            _createElementVNode("i", {
              class: _normalizeClass(['icon', item.icon])
            }, null, 2),
            _createElementVNode("span", null, _toDisplayString(item.name), 1)
          ], 8, _hoisted_10)
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        _hoisted_13,
        (zyImgList.value.length > 0)
          ? (_openBlock(), _createBlock(_component_van_swipe, {
              key: 0,
              loop: true,
              "indicator-color": "#eeb230",
              class: "zy_swipe"
            }, {
              default: _withCtx(() => [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(zyImgList.value, (item, index) => {
                  return (_openBlock(), _createBlock(_component_van_swipe_item, {
                    key: index,
                    class: "van-swipe-item",
                    onClick: ($event: any) => (swipeClickColumn(item))
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("img", {
                        class: "home_img",
                        loading: "lazy",
                        fit: "cover",
                        src: getResourceimgUrl(item),
                        alt: ""
                      }, null, 8, _hoisted_14)
                    ]),
                    _: 2
                  }, 1032, ["onClick"]))
                }), 128))
              ]),
              _: 1
            }))
          : _createCommentVNode("", true),
        _hoisted_15,
        _createVNode(ListWithRefreshAndLazyLoad, {
          ref_key: "listRef",
          ref: listRef,
          list: list.value,
          "onUpdate:list": _cache[2] || (_cache[2] = ($event: any) => ((list).value = $event)),
          params: params.value,
          getDataAPI: _unref(getDataAPI),
          noDataText: "暂时没有资源哦~",
          offset: "5",
          class: "row-flex"
        }, {
          default: _withCtx(() => [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(list.value, (item, i) => {
              return (_openBlock(), _createElementBlock("div", {
                class: "list-item flex-column",
                key: i,
                onClick: ($event: any) => (gotoDetail(item))
              }, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("img", {
                    loading: "lazy",
                    src: getimgUrl(item, '2'),
                    alt: ""
                  }, null, 8, _hoisted_18)
                ]),
                _createElementVNode("p", _hoisted_19, [
                  _createElementVNode("span", _hoisted_20, _toDisplayString(item.zymc), 1)
                ])
              ], 8, _hoisted_16))
            }), 128))
          ]),
          _: 1
        }, 8, ["list", "params", "getDataAPI"])
      ])
    ])
  ]))
}
}

})